import styled from 'styled-components';

export const Wrapper = styled.div`
  @media screen and (min-width: 1280px) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;
